import withPropsOnChange from 'recompose/withPropsOnChange';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import withHandlers from 'recompose/withHandlers';
import lifecycle from 'recompose/lifecycle';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import React from 'react';
import PropTypes from 'prop-types';

import withCanViewWaitingList from
  '../../../../common/hoc/withCanViewWaitingList';
import { getCustomersWaitingForBarber } from '../../../waitingList/waitingListCustomers/selectors';
import { getDate } from '../../appointmentSelector';
import { getRoleIdType } from '../../../../auth/selectors';
import {
  barberFetchWaitingListCustomers,
  shopFetchWaitingListCustomers,
} from '../../../waitingList/waitingListCustomers/actions';

const CustomersWaiting = ({ customersWaiting }) => <div className="c-waiting-customers">{customersWaiting}</div>;
CustomersWaiting.propTypes = {
  customersWaiting: PropTypes.number,
};
CustomersWaiting.defaultProps = {
  customersWaiting: 2,
};

export default compose(
  withCanViewWaitingList,
  branch(props => !props.canViewWaitingList, renderNothing),
  connect(
    (state, ownProps) => {
      const date = getDate(state);
      return {
        shopOrBarber: getRoleIdType(state),
        customersWaiting: getCustomersWaitingForBarber(state, ownProps.barberId, date),
        date,
      };
    },
    {
      shopFetchWaitingListCustomers,
      barberFetchWaitingListCustomers,
    },
  ),
  withHandlers({
    fetch: props => () => {
      if (props.shopOrBarber.type === 'shop') {
        return props.shopFetchWaitingListCustomers(props.shopOrBarber.id, props.date);
      }
      return props.barberFetchWaitingListCustomers(props.shopOrBarber.id, props.date);
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetch();
    },
  }),
  withPropsOnChange(
    ['date'],
    (props) => {
      props.fetch();
    }
  ),
  branch(props => !props.customersWaiting, renderNothing),
)(CustomersWaiting);
